import palette from '@telus-uds/palette-koodo/palette.json';
var getThemeColors = function (theme, defaultBorderColor) {
    var _a = palette.color.values, pink = _a.pink, purple = _a.purple, green = _a.green, black = _a.black, orange = _a.orange, white = _a.white, blue = _a.blue;
    // These filters assume that the original color of the svg is "black.value"
    var svgFilterMosque = 'invert(22%) sepia(80%) saturate(2221%) hue-rotate(161deg) brightness(90%) contrast(104%)';
    var svgFilterwhite = 'invert(100%) sepia(1%) saturate(7497%) hue-rotate(200deg) brightness(101%) contrast(101%)';
    var colors = {
        orange: {
            bgInactive: orange.value,
            bgActive: black.value,
            textInactive: black.value,
            textActive: white.value
        },
        green: {
            bgInactive: green.value,
            bgActive: black.value,
            textInactive: black.value,
            textActive: white.value,
            svgBonusInactive: svgFilterMosque
        },
        blue: {
            bgInactive: blue.value,
            bgActive: black.value,
            textInactive: black.value,
            textActive: white.value
        },
        purple: {
            bgInactive: purple.value,
            bgActive: black.value,
            textInactive: black.value,
            textActive: white.value
        },
        pink: {
            bgInactive: pink.value,
            bgActive: black.value,
            textInactive: black.value,
            textActive: white.value,
            svgBonusInactive: svgFilterwhite
        },
        standard: {
            bgInactive: white.value,
            bgActive: black.value,
            textInactive: black.value,
            textActive: white.value,
            borderColor: black.value
        },
        default: {
            bgActive: defaultBorderColor
        }
    };
    return colors[theme];
};
export default getThemeColors;
